import { useEffect, useState } from 'react';
import axios from 'axios';
import endpoints from '../define/endpoints';

export function useVoucherPreviewTemplate(listingId, name, message, seats, productId) {
  const [template, setTemplate] = useState([]);
  useEffect(() => {
    (async function () {
      const params = {
        locale: window.freedomeConfig.locale,
        voucher_name: name,
        voucher_message: message,
        preview_items: seats
      };

      const url = productId
        ? `${endpoints.core}/listings/${listingId}/voucher-preview/${productId}`
        : `${endpoints.core}/listings/${listingId}/voucher-preview`;

      const { data } = await axios.get(url, { params });
      setTemplate(data);
    })();
  }, []);

  return template;
}
